import e from "./generateUtilityClasses.mjs";
import n from "./generateUtilityClass.mjs";
function r(t) {
  return n("MuiInputBase", t);
}
const i = e("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), s = i;
export {
  s as default,
  r as getInputBaseUtilityClass
};
//# sourceMappingURL=inputBaseClasses.mjs.map
